import React, { useEffect, SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from 'components/icons/Icon';
import iconPerson from 'images/icons/person.svg';
import iconMoney from 'images/icons/money.svg';
import iconHeart from 'images/icons/heart.svg';
import EmployeeAvatar from 'images/avatars/employee.png';
import {
  BodyWrapper,
  MetricsWrapper,
  HeardMargin,
  StyleTable,
  ButtonStyled,
  MarginUpload,
  MarginExcelUpload
} from './Styled';
import {
  StyledTooltipWrapper,
  TooltipMessage
} from 'components/TooltipWrapper/StyledTooltipWrapper';
import MetricBox from 'components/boxes/MetricBox';
import MetricImgBox from 'components/boxes/MetricBoxImg';
import SingleDataBox from 'components/boxes/SingleDataBox';
import NetworkParticipationBox from 'components/boxes/NetworkParticipationBox';
import { useDispatch, useSelector } from 'react-redux';
import { getReport } from 'services/rest/Report/getReport';
import { selectUser } from 'redux/slices/userSlice';
import DetailChallengeTable from './DetailChallengeTable';
import { getGroupAmbassador } from 'services/rest/GetGroupAmbassador/GetGroupAmbassador';
import { sortGroups } from 'helpers/groupsHelper';
import {
  selectGroupAmbassador,
  setData,
  setLoadingGroupAmbassador
} from 'redux/slices/GroupAmbassador/GroupAmbassadorSlice';
import { IGroupAmssador } from 'redux/slices/GroupAmbassador/GroupAmbassador.interface';
import { nFormatter } from 'helpers/formatHelper';
import moment from 'moment';
import 'moment/locale/es';
import { selectCompany } from 'redux/slices/Company/CompanySlice';
import Button from 'components/buttons/Button';
import { ErrorAlert, SuccessAlert } from 'components/Alert';
import { getCurrentCompany } from 'helpers/companyHelper';
import { createManualReport } from 'services/rest/Report/createManualReport';
import Spinner from 'components/Spinner/Spinner';
import Modal from 'react-responsive-modal';
import { useForm } from 'react-hook-form';
import UploadExcel from 'components/inputs/UploadExcel';
import Input from 'components/inputs/Input';
import * as XLSX from 'xlsx';
import { headerBonusValidations } from 'Utils/ExcelValidation';
import { uploadBonusExcel } from 'services/rest/Bonus/uploadBonusExcel';
import ErrorsReport from 'components/errorsReport';

interface DetailChallengeProps {
  challenge: any;
  allParticipants: any;
  socialNetworks: any;
}

interface FormData {
  challengeId: number;
  records: any;
}

const DetailChallengeAdmin: React.FC<DetailChallengeProps> = props => {
  const { challenge, allParticipants, socialNetworks } = props;
  const [successAlertVisible, setSuccessAlertVisible] = useState(false);
  const [
    successReminderAlertVisible,
    setSuccessReminderAlertVisible
  ] = useState(false);
  const [updateError, setUpdateError] = useState<string | null>(null);
  const { currentUser } = useSelector(selectUser);
  const { t } = useTranslation([
    'admin_campaign_details',
    'challenge',
    'report_page',
    'upload_excel'
  ]);
  const dispatch = useDispatch();
  const { groupsAmbassador = [] } = useSelector(selectGroupAmbassador);
  const { company } = useSelector(selectCompany);
  const [visible, setVisible] = useState({
    totalValorization: false,
    potential_reach: false,
    estimated_reach: false
  });
  const [networksBoxItems, setNetworksBoxItems] = useState([
    { linked: true, network: 'facebook', percentage: '0' },
    { linked: true, network: 'twitter', percentage: '0' },
    { linked: true, network: 'linkedin', percentage: '0' },
    { linked: true, network: 'instagram', percentage: '0' },
    { linked: true, network: 'tiktok', percentage: '0' },
    { linked: true, network: 'snapchat', percentage: '0' },
    { linked: true, network: 'youtube', percentage: '0' },
    { linked: true, network: 'threads', percentage: '0' },
    { linked: true, network: 'otros', percentage: '0' }
  ]);
  const subdomain = getCurrentCompany();
  const changeTooltip = (tooltipType: string, state: boolean) => {
    const tooltipTypes = {
      ...visible,
      [tooltipType]: state
    };
    setVisible(tooltipTypes);
  };

  const { handleSubmit } = useForm<FormData>();

  const getGroup = async (name: string) => {
    await getGroupAmbassador(currentUser?.token, 1, 500, name)
      .then(response => {
        const group = sortGroups(response.data.data.groups.docs);
        const ambassadors = sortGroups(response.data.data.ambassadors.docs);
        const groupAmbassador: IGroupAmssador = {
          groups: group,
          ambassador: ambassadors
        };
        dispatch(setData(groupAmbassador));
        dispatch(setLoadingGroupAmbassador(false));
      })
      .catch(error => {
        dispatch(setLoadingGroupAmbassador(false));
      });
  };

  const [isLoading, setIsLoading] = useState(false);
  const [reminderSent, setReminderSent] = useState(false);

  useEffect(() => {
    dispatch(setLoadingGroupAmbassador(true));
    validatePercentageContentBySocialNetwork(challenge);
    getGroup('');
  }, []);

  const validatePercentageContentBySocialNetwork = (challenge: any) => {
    const result: any[] = Object.keys(
      challenge.percentageContentBySocialNetwork
    ).map((key: string) => {
      return {
        linked: challenge[key],
        network: key,
        percentage: challenge?.percentageContentBySocialNetwork[key]?.toString()
      };
    });
    setNetworksBoxItems(result);
  };

  const addDefaultPicture = (evt: SyntheticEvent<HTMLImageElement, Event>) => {
    evt.currentTarget.src = EmployeeAvatar;
  };

  const timeLine = (startDate: any, finishDate: any) => {
    startDate = moment(startDate);
    const startMonth = startDate.format('MMM');
    const startDay = startDate.format('D');
    finishDate = moment(finishDate);
    const finishMonth = finishDate.format('MMM');
    const finishDay = finishDate.format('D');
    return `${startMonth} ${startDay} - ${finishMonth} ${finishDay}`;
  };
  const downloadReport = async (typeReport: string) => {
    const { data } = await getReport(
      currentUser?.token,
      challenge?.id,
      typeReport,
      null
    );
    if (data.data) {
      setSuccessAlertVisible(true);
    } else {
      setUpdateError(t('report_page:error_page'));
    }
  };
  const manualReport = async (typeReport: string) => {
    setIsLoading(true);
    try {
      const { data } = await createManualReport(
        currentUser?.token,
        challenge?.id,
        typeReport
      );
      if (data.data) {
        setSuccessReminderAlertVisible(true);
        setReminderSent(true);
      } else {
        setUpdateError(t('report_page:error_page'));
      }
    } catch (error) {
      setUpdateError(t('report_page:error_page'));
    } finally {
      setIsLoading(false);
    }
  };

  const [open, setOpen] = useState(false);
  const [nameFile, setNameFile] = useState('');
  const [records, setRecords] = useState([]);
  const [fileErrors, setFileErrors] = useState(false);
  const [excelError, setExcelError] = useState<any>();
  const [loader, setLoader] = useState(false);
  const [notificationEmail, setNotificationEmail] = useState('');
  const [massiveSuccess, setMassiveSuccess] = useState<string | null>(null);
  // Formato nuevo (P&G): el challenge se identifica por el nombre exacto en la
  // columna "Selected campaign". Se activa por company vía challengeExtraSettings.
  const isMassiveByName =
    company?.challengeExtraSettings?.massiveUploadFormat === 'challenge-name';
  const translationHeadersData = t('upload_excel:bonusHeaders', {
    returnObjects: true,
    defaultValue: []
  });
  const translationHeaders =
    Object.keys(translationHeadersData).length > 0
      ? translationHeadersData
      : [];

  const formatRecordsData = (records: any) => {
    records = records.filter((entry: any) => {
      return /\S/.test(entry);
    });
    const result = [] as any;
    const recordsFiltered = records.filter((data: any) => {
      const filtered = data?.filter((item: any) => {
        const value = item.toString().trim();
        return value.length > 0;
      });
      return filtered.length > 0;
    });
    if (recordsFiltered.length > 0) {
      const excelValidation = headerBonusValidations(
        recordsFiltered[0],
        translationHeaders
      );
      if (excelValidation) {
        setUpdateError(
          t(`upload_excel:bonusHeaders:errors:${excelValidation}`)
        );
        setNameFile('');
      } else {
        if (recordsFiltered.length > 1) {
          const onlyData = recordsFiltered.slice(1);
          const validSocialNetworks = [
            'facebook',
            'twitter',
            'linkedin',
            'instagram',
            'tiktok',
            'snapchat',
            'youtube',
            'threads',
            'otros'
          ];
          const validStatuses = ['pending', 'approved', 'rejected'];
          const rowErrors: string[] = [];

          onlyData.forEach((record: any, index: number) => {
            const rowNum = index + 2;
            const email = record[0]?.toString().trim() || '';
            const socialNetwork = record[1]?.toString().trim() || '';
            const url = record[2]?.toString().trim() || '';
            const points = record[3]?.toString().trim() || '';
            const status = record[4]?.toString().trim().toLowerCase() || '';

            if (!email) {
              rowErrors.push(`Fila ${rowNum}: el campo Email está vacío`);
            }

            const rowRef = email
              ? `Fila ${rowNum} (${email})`
              : `Fila ${rowNum}`;

            if (!socialNetwork) {
              rowErrors.push(`${rowRef}: el campo Red Social está vacío`);
            } else if (
              !validSocialNetworks.includes(socialNetwork.toLowerCase())
            ) {
              rowErrors.push(
                `${rowRef}: red social '${socialNetwork}' no es válida. Valores permitidos: ${validSocialNetworks.join(
                  ', '
                )}`
              );
            }

            if (!url) {
              rowErrors.push(`${rowRef}: el campo URL está vacío`);
            }

            if (points === '' || isNaN(Number(points))) {
              rowErrors.push(
                `${rowRef}: el campo Puntos debe ser un número válido`
              );
            }

            if (!status) {
              rowErrors.push(`${rowRef}: el campo Estado está vacío`);
            } else if (!validStatuses.includes(status)) {
              rowErrors.push(
                `${rowRef}: estado '${record[4]
                  ?.toString()
                  .trim()}' no es válido. Valores permitidos: ${validStatuses.join(
                  ', '
                )}`
              );
            }

            const valorization = record[5]?.toString().trim() ?? '';
            if (!valorization) {
              rowErrors.push(`${rowRef}: el campo Valorización está vacío`);
            }
          });

          if (rowErrors.length > 0) {
            setUpdateError(rowErrors.join('\n'));
            setNameFile('');
          } else {
            onlyData.map((record: any) => {
              const obj = {} as any;
              obj.email = record[0];
              obj.socialNetwork = record[1];
              obj.url = record[2];
              obj.points = record[3];
              obj.status = record[4];
              obj.valorization = record[5];
              result.push(obj);
            });
          }
        } else {
          setUpdateError(
            t('upload_excel:bonusHeaders:errors:empty_excel_error')
          );
          setNameFile('');
        }
      }
    } else {
      setUpdateError(t('upload_excel:bonusHeaders:errors:empty_excel_error'));
      setNameFile('');
    }
    return result;
  };

  // Parser del FORMATO NUEVO (P&G): mapea columnas por NOMBRE de encabezado,
  // permite filas sin URL y NO valida fila por fila (eso lo hace el backend y
  // lo reporta por email). Conserva el nº de fila original del Excel.
  const formatRecordsDataByName = (recordsData: any) => {
    const norm = (v: any) =>
      (v ?? '')
        .toString()
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ');

    // Ubicar la fila de encabezados (la que tenga MAIL + Selected campaign).
    let headerIdx = -1;
    for (let i = 0; i < recordsData.length; i++) {
      const r = recordsData[i];
      if (!Array.isArray(r)) continue;
      const hs = r.map((h: any) => norm(h));
      if (
        hs.includes('selected campaign') &&
        (hs.includes('mail') || hs.includes('correo') || hs.includes('email'))
      ) {
        headerIdx = i;
        break;
      }
    }
    if (headerIdx === -1) {
      setUpdateError(
        'El archivo no tiene las columnas requeridas: MAIL, Selected campaign y Social media post.'
      );
      setNameFile('');
      return [];
    }

    const headers = recordsData[headerIdx].map((h: any) => norm(h));
    const findCol = (cands: string[]) =>
      headers.findIndex((h: string) => cands.includes(h));
    const emailIdx = findCol(['mail', 'correo', 'email']);
    const urlIdx = findCol(['social media post']);
    const challengeIdx = findCol(['selected campaign']);
    const countryIdx = findCol(['country', 'pais']);

    const missing: string[] = [];
    if (emailIdx === -1) missing.push('MAIL');
    if (challengeIdx === -1) missing.push('Selected campaign');
    if (urlIdx === -1) missing.push('Social media post');
    if (missing.length > 0) {
      setUpdateError(
        `El archivo no tiene las columnas requeridas: ${missing.join(', ')}.`
      );
      setNameFile('');
      return [];
    }

    const get = (row: any, idx: number) =>
      idx >= 0 && row[idx] != null ? row[idx].toString().trim() : '';

    const result: any[] = [];
    for (let i = headerIdx + 1; i < recordsData.length; i++) {
      const row = recordsData[i];
      if (!Array.isArray(row)) continue;
      const email = get(row, emailIdx);
      const url = get(row, urlIdx);
      const challengeName = get(row, challengeIdx);
      const country = get(row, countryIdx);
      if (!email && !url && !challengeName) continue; // fila vacía
      result.push({
        rowNumber: i + 1, // nº de fila tal cual el Excel (1-based)
        email,
        url,
        challengeName,
        country
      });
    }

    if (result.length === 0) {
      setUpdateError(t('upload_excel:bonusHeaders:errors:empty_excel_error'));
      setNameFile('');
    }
    return result;
  };

  const saveByteArray = (byte: any) => {
    return new Blob([byte], { type: 'xlxs' });
  };

  const filePathset = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    setNameFile(e.target.files[0].name);
    setFileErrors(false);
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const recordsData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const recordsToJSON = isMassiveByName
        ? formatRecordsDataByName(recordsData)
        : formatRecordsData(recordsData);
      setRecords(recordsToJSON);
    };
    reader.readAsArrayBuffer(e.target.files[0]);
  };

  const onSubmit = async (formData: FormData) => {
    if (records.length === 0 || nameFile === '') {
      setFileErrors(true);
      return;
    }

    // Formato nuevo (P&G): procesamiento asíncrono + email de resultado.
    if (isMassiveByName) {
      // Acepta varios emails separados por coma.
      const emails = notificationEmail
        .split(',')
        .map(e => e.trim())
        .filter(e => e.length > 0);
      const invalids = emails.filter(
        e => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
      );
      if (emails.length === 0 || invalids.length > 0) {
        setUpdateError(
          invalids.length > 0
            ? `Email(s) inválido(s): ${invalids.join(
                ', '
              )}. Separalos por coma.`
            : 'Ingresá al menos un email válido para recibir el resultado de la carga.'
        );
        return;
      }
      setFileErrors(false);
      setLoader(true);
      const { data, errors } = await uploadBonusExcel(currentUser?.token, {
        challengeId: challenge?.id,
        records,
        notificationEmail: emails.join(',')
      });
      setLoader(false);
      if (data?.data?.received) {
        setOpen(false);
        setRecords([]);
        setNameFile('');
        setNotificationEmail('');
        setMassiveSuccess(
          `Carga recibida. Te enviaremos un email a ${emails.join(
            ', '
          )} con el resultado del procesamiento.`
        );
      } else if (errors) {
        setUpdateError(errors.data || 'No se pudo procesar la carga.');
      }
      return;
    }

    setLoader(true);
    formData.records = records;
    if (formData.records.length <= 0) {
      setFileErrors(false);
      setLoader(false);
    } else {
      setFileErrors(false);
      formData.challengeId = challenge?.id;
      const { data, errors } = await uploadBonusExcel(
        currentUser?.token,
        formData
      );
      if (data) {
        if (data.data.processed) {
          window.location.reload();
        } else {
          setLoader(false);
          const toBuffer = Buffer.from(data.data.excel, 'base64');
          const toByteArray = saveByteArray(toBuffer);
          const toLink = window.URL.createObjectURL(toByteArray);
          setExcelError(toLink);
        }
      }
      if (errors) {
        setUpdateError(errors.data);
        setLoader(false);
      }
    }
  };

  function linkifyText(text: string) {
    // Detecta tokens completos tipo: Brief=https://...
    const pattern = /[^=\s]+=https?:\/\/[^\s]+/g;

    const elements: (string | JSX.Element)[] = [];
    let lastIndex = 0;

    for (const match of text.matchAll(pattern)) {
      const fullMatch = match[0]; // ejemplo: "Brief=https://...."
      const start = match.index!;

      // Agregar el texto antes del match
      if (start > lastIndex) {
        elements.push(text.slice(lastIndex, start));
      }

      // Extraer la URL real (todo lo después del "=")
      const label = fullMatch.split('=')[0];
      const url = fullMatch.split('=')[1];

      // Agregar el enlace
      elements.push(
        <a
          key={start}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="custom-link"
        >
          {label}
        </a>
      );

      lastIndex = start + fullMatch.length;
    }

    // Agregar texto después del último match
    if (lastIndex < text.length) {
      elements.push(text.slice(lastIndex));
    }

    return elements;
  }

  return (
    <>
      {updateError && (
        <ErrorAlert
          text={updateError}
          allowClose={true}
          onClose={() => setUpdateError(null)}
        />
      )}
      {successAlertVisible && (
        <SuccessAlert
          text={t('report_page:success_email')}
          allowClose={true}
          onClose={() => setSuccessAlertVisible(false)}
        />
      )}
      {successReminderAlertVisible && (
        <SuccessAlert
          text={t('report_page:reminder_success')}
          allowClose={true}
          onClose={() => setSuccessReminderAlertVisible(false)}
        />
      )}
      {massiveSuccess && (
        <SuccessAlert
          text={massiveSuccess}
          allowClose={true}
          onClose={() => setMassiveSuccess(null)}
        />
      )}
      <HeardMargin>
        <img
          alt="challengePhoto"
          src={challenge?.photo}
          className="margin_img"
        />
        <div className="margin_container">
          <span>
            <Icon size="small" name="calendar-o" color="#bd10e0" />
            {timeLine(challenge?.startDate, challenge?.finishDate)}
          </span>
          <h1>{challenge?.name}</h1>
          <p className="description">{linkifyText(challenge?.content || '')}</p>
          {challenge?.reportSettings && (
            <div>
              <h4>{challenge?.reportSettings?.reportTitle}</h4>
              <a
                href={challenge?.reportSettings?.urlReports}
                target="_blank"
                rel="noopener noreferrer"
                className="custom-link"
              >
                {challenge?.reportSettings?.buttonTitle}
              </a>
            </div>
          )}
          <div>
            <h4>{t('admin_campaign_details:participating_groups')}</h4>
            <div className="name_tag_container">
              {Object.values(challenge?.groupsIds).map((group: any) => (
                <span className="name_tag" key={group}>
                  <span className="tag">
                    {Object.values(groupsAmbassador?.groups).map(
                      (groups: any) => groups?.id == group && groups?.name
                    )}
                  </span>
                </span>
              ))}
            </div>
          </div>
          <div>
            <h4>{t('admin_campaign_details:people')}</h4>
            <div className="people-tags">
              {allParticipants
                .slice(0, 5)
                .map((participant: any, index: number) => (
                  <img
                    alt="participantPhoto"
                    key={index}
                    src={participant.photo || EmployeeAvatar}
                    className="circle_people"
                    onError={evt => addDefaultPicture(evt)}
                  />
                ))}
              {allParticipants.slice(4, allParticipants.length).length > 0 && (
                <div className="circle-tag plus-tag">
                  +{allParticipants.slice(5, allParticipants.length).length}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className="action-button">
              <Icon size="small" name="circle-info" color="#05559C" />
              <a href={`/challenges/${challenge?.id}/edit`}>
                {t('challenge:challenge_details')}
              </a>
              {challenge?.status === 'activated' && (
                <>
                  <div className="vl"></div>
                  <Icon size="small" name="whatsapp" color="#05559C" />
                  <a
                    href={`https://api.whatsapp.com/send/?phone&text=${t(
                      'challenge:new_challenge_avaiable'
                    )}-https://${subdomain}.advocatespro.com/challenges/detail/${
                      challenge?.id
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t('challenge:share_whatsapp')}
                  </a>
                </>
              )}
              {challenge?.notifiedReminded === false &&
                challenge?.status === 'activated' &&
                !reminderSent && (
                  <>
                    <div className="vl"></div>
                    {isLoading ? (
                      <Spinner size="small" />
                    ) : (
                      <>
                        <Icon size="small" name="bell" color="#05559C" />
                        <span onClick={() => manualReport('challenge')}>
                          {t('admin_campaign_details:send_reminder')}
                        </span>
                      </>
                    )}
                  </>
                )}

              {challenge?.status === 'activated' &&
                company?.company_permission?.allowSelfRegistration && (
                  <>
                    <div className="vl"></div>
                    <Icon size="small" name="file" color="#05559C" />
                    <span
                      onClick={() => {
                        setOpen(true);
                      }}
                    >
                      {t('challenge:bulk_upload')}
                    </span>
                  </>
                )}
            </div>
          </div>
        </div>
      </HeardMargin>
      {!company?.challengeExtraSettings?.hideModules && (
        <>
          <h1>{t('admin_campaign_details:summary')}</h1>
          <BodyWrapper>
            <MetricsWrapper className="metrics-detail">
              <StyledTooltipWrapper visible={false}>
                <SingleDataBox>
                  <MetricImgBox
                    iconName={iconPerson}
                    value={`${challenge?.ambassadorsParticipating} / ${challenge?.totalAmbassadors}`}
                    text={t(
                      'admin_campaign_details:ambassadors_generate_content'
                    )}
                  />
                </SingleDataBox>
              </StyledTooltipWrapper>

              <StyledTooltipWrapper visible={false}>
                <SingleDataBox>
                  <MetricBox
                    iconName="report"
                    value={challenge?.totalParticipation}
                    text={t('challenge:total_contents_approved')}
                  />
                </SingleDataBox>
              </StyledTooltipWrapper>

              <StyledTooltipWrapper
                visible={visible.totalValorization}
                onMouseOver={() => changeTooltip('totalValorization', true)}
                onMouseOut={() => changeTooltip('totalValorization', false)}
              >
                <SingleDataBox>
                  <MetricImgBox
                    iconName={iconMoney}
                    value={`${company?.currency?.sign}${nFormatter(
                      challenge?.totalValorization
                    )}`}
                    money={company?.currency?.code}
                    text={t('challenge:total_valorization_singular')}
                  />
                  <TooltipMessage>
                    {t('challenge:total_valorization_tooltip')}
                  </TooltipMessage>
                </SingleDataBox>
              </StyledTooltipWrapper>

              <StyledTooltipWrapper
                visible={visible.potential_reach}
                onMouseOver={() => changeTooltip('potential_reach', true)}
                onMouseOut={() => changeTooltip('potential_reach', false)}
              >
                <SingleDataBox>
                  <MetricBox
                    iconName="total-reach"
                    value={`${nFormatter(challenge?.potentialReach)}`}
                    text={t('challenge:potential_reach_singular')}
                  />
                  <TooltipMessage>
                    {t('challenge:potential_reach_tooltip')}
                  </TooltipMessage>
                </SingleDataBox>
              </StyledTooltipWrapper>

              <StyledTooltipWrapper
                visible={visible.estimated_reach}
                onMouseOver={() => changeTooltip('estimated_reach', true)}
                onMouseOut={() => changeTooltip('estimated_reach', false)}
              >
                <SingleDataBox>
                  <MetricImgBox
                    iconName={iconHeart}
                    value={`${nFormatter(challenge?.estimatedReach)}`}
                    text={t('challenge:estimated_reach_singular')}
                  />
                  <TooltipMessage>
                    {t('challenge:estimated_reach_tooltip')}
                  </TooltipMessage>
                </SingleDataBox>
              </StyledTooltipWrapper>

              <StyledTooltipWrapper visible={false}>
                <SingleDataBox>
                  <NetworkParticipationBox
                    items={networksBoxItems}
                    detailCampaign={true}
                    columns={2}
                  />
                </SingleDataBox>
              </StyledTooltipWrapper>
            </MetricsWrapper>
          </BodyWrapper>
        </>
      )}

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        center
        styles={{ modal: { textAlign: 'center' } }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <MarginUpload>
            <div>
              <p>
                {company?.challengeExtraSettings?.massiveTitle ||
                  t('challenge:upload')}
              </p>
            </div>
            <MarginExcelUpload>
              <UploadExcel
                name="records"
                onChange={filePathset}
                errors={fileErrors}
                nameFile={nameFile}
                setNameFile={setNameFile}
                setExcelError={setExcelError}
              />
            </MarginExcelUpload>
            {excelError && <ErrorsReport file={excelError} />}
            {isMassiveByName && (
              <div style={{ marginTop: 16, textAlign: 'left' }}>
                <label style={{ fontSize: 13, fontWeight: 600 }}>
                  Email(s) para recibir el resultado de la carga (separados por
                  coma)
                </label>
                <Input
                  type="text"
                  name="notificationEmail"
                  placeholder="correo1@empresa.com, correo2@empresa.com"
                  value={notificationEmail}
                  onChange={(e: any) => setNotificationEmail(e.target.value)}
                />
              </div>
            )}
          </MarginUpload>
          <Button
            value={t('campaign_section:Enviar')}
            variant="tertiary"
            loader={loader}
          />
        </form>
      </Modal>

      {challenge.bonusList.length > 0 && (
        <>
          <StyleTable>
            <DetailChallengeTable
              contentList={challenge?.bonusList}
              socialNetworks={socialNetworks}
            ></DetailChallengeTable>
          </StyleTable>
          <ButtonStyled>
            <Button
              onClick={() => downloadReport('CHALLENGE')}
              value={t('report_page:generate_report')}
              variant="primary"
            />
          </ButtonStyled>
        </>
      )}
    </>
  );
};

export default DetailChallengeAdmin;
